import React from 'react';

const LockV2 = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    style: { ...style, overflow: "visible" },
    className,
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.875 8.75H15.9375V5.9375C15.9375 2.66406 13.2734 0 10 0C6.72656 0 4.0625 2.66406 4.0625 5.9375V8.75H3.125C2.08984 8.75 1.25 9.58984 1.25 10.625V18.125C1.25 19.1602 2.08984 20 3.125 20H16.875C17.9102 20 18.75 19.1602 18.75 18.125V10.625C18.75 9.58984 17.9102 8.75 16.875 8.75ZM12.8125 8.75H7.1875V5.9375C7.1875 4.38672 8.44922 3.125 10 3.125C11.5508 3.125 12.8125 4.38672 12.8125 5.9375V8.75Z",
      fill: "#FFC21B"
    }
  )
);
LockV2.displayName = "Icons.LockV2";

export { LockV2 };
//# sourceMappingURL=LockV2.js.map
